module.exports = __webpack_public_path__ + "static/media/main_skybox_BK.d7ae0012.png";